import React from 'react';
import { Link } from 'react-router-dom';
import './Industries.css';

// --- PREMIUM CUSTOM ICONS ---
const IndustryIcons = {
  MultiSpecialty: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21h18"></path>
      <path d="M5 21V7l8-4 8 4v14"></path>
      <path d="M13 21v-8"></path>
      <path d="M9 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"></path>
    </svg>
  ),
  Clinic: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 2v4"></path>
      <path d="M16 2v4"></path>
      <rect width="18" height="18" x="3" y="4" rx="2"></rect>
      <path d="M3 10h18"></path>
      <path d="M10 16h4"></path>
      <path d="M12 14v4"></path>
    </svg>
  ),
  Diagnostic: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 2v7.31"></path>
      <path d="M14 9.3V1.99"></path>
      <path d="M8.5 2h7"></path>
      <path d="M14 9.3a6.5 6.5 0 1 1-4 0"></path>
      <path d="M5.52 16h12.96"></path>
    </svg>
  ),
  Retail: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"></path>
      <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
      <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"></path>
      <path d="M2 7h20"></path>
      <path d="M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7"></path>
    </svg>
  )
};

const Industries = () => {
  const industries = [
    {
      title: "Multi-Specialty Hospitals",
      icon: <IndustryIcons.MultiSpecialty />,
      desc: "Manage complex patient flows across multiple departments with a single QR scan.",
      features: ["Unified Patient ID", "Inter-dept Referrals", "Centralized Billing"]
    },
    {
      title: "Clinics & Polyclinics",
      icon: <IndustryIcons.Clinic />,
      desc: "Streamline appointments and reduce waiting room congestion for faster care.",
      features: ["Instant Check-in", "Digital Prescriptions", "Quick Vitals Log"]
    },
    {
      title: "Diagnostic Labs",
      icon: <IndustryIcons.Diagnostic />,
      desc: "Automate sample tracking and deliver reports directly to the patient's phone.",
      features: ["Sample Barcoding", "Auto-Report Gen", "SMS/WhatsApp Alerts"]
    },
    {
      title: "Retail Pharmacies",
      icon: <IndustryIcons.Retail />,
      desc: "Connect directly with doctors for error-free prescription fulfillment.",
      features: ["Inventory Sync", "E-Prescription", "Refill Reminders"]
    }
  ];

  return (
    <div className="industries-premium">
      {/* Hero Section */}
      <section className="industries-hero">
        <div className="container">
          <span className="badge-glow">Sectors We Serve</span>
          <h1>Built for Every Scale of Healthcare</h1>
          <p>From single clinics to massive hospital chains, Smart QR scales to fit your needs.</p>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="industries-content">
        <div className="container">
          <div className="industries-grid">
            {industries.map((item, index) => (
              <div key={index} className="industry-card-glass">
                <div className="industry-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                <div className="industry-features">
                  {item.features.map((feat, i) => (
                    <span key={i} className="feat-tag">✓ {feat}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="industry-cta">
        <div className="container">
          <div className="cta-box">
            <h2>Ready to upgrade your facility?</h2>
            <Link to="/contact" className="btn-primary">Get a Custom Quote</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Industries;